import React, { useMemo } from 'react';

import { LoadingWheel } from '../base/LoadingWheel';
import { Select } from '../base/Select';

import useApplianceModels from '../../data/appliance/useApplianceModel';

export interface ModelSelectProps {
  manufacturer: string;
  type?: string;
  label?: string;
}

export const ModelSelect = React.forwardRef<any, ModelSelectProps>(
  ({ manufacturer, type, label, ...rest }, ref) => {
    const { applianceModels } = useApplianceModels(manufacturer, type);

    if (applianceModels.isLoading) {
      return (
        <div className="flex items-center justify-center">
          <LoadingWheel size="sm" />
        </div>
      );
    } else {
      return (
        <Select
          disabled={!manufacturer}
          ref={ref}
          label={label ? label : 'Model'}
          {...rest}
        >
          <option disabled selected hidden></option>
          {applianceModels.data?.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </Select>
      );
    }
  }
);
